$(function() {

    $.healthcare = {};

    $.healthcare.delayFadeOut = ($("#healthcare-container").next('section').hasClass('profile-section')) ? false : true;

    $.healthcare.lastProfile = false;

    // durations

    $.healthcare.duration = '75%';

    $.healthcare.calculatePinDuration = function() {
        var contentHeight = $('#healthcare-container .content-container').outerHeight();
        if ($.healthcare.lastProfile) {
            $.healthcare.pinDuration = 0;
        } else {
            $.healthcare.pinDuration = Math.round(contentHeight + $(window).innerHeight());
        }
        return $.healthcare.pinDuration;
	};

    $.healthcare.zoomDuration = '100%';

    $.healthcare.endDuration = ($.healthcare.delayFadeOut) ? '150%' : '50%';

    // timelines

    $.healthcare.tl = {};

    // in

	$.healthcare.tl.in = new TimelineMax();

    $.healthcare.tl.in.addLabel("start");

    $.healthcare.tl.in.set("#healthcare-container", { visibility: "visible" }, "start");﻿

    if (!$.ms) {

        $.healthcare.tl.in.from("#healthcare-svg .line-1", 1, { x:"2560" }, "start");
        $.healthcare.tl.in.from("#healthcare-svg .line-2", 1, { x:"2560", delay: 0.25 }, "start");
        $.healthcare.tl.in.from("#healthcare-svg .line-3", 1, { x:"2560", delay: 0.5 }, "start");
        $.healthcare.tl.in.add(function(){ /* pause */ }, "+=0.25");

        new ScrollMagic.Scene({ triggerElement: '#healthcare-in', triggerHook: 'onEnter', duration: $.healthcare.duration })
        	.setTween($.healthcare.tl.in)
        	// .addIndicators({name: 'healthcare in'})
        	.addTo($.controller);

    }

    // pin

    new ScrollMagic.Scene({ triggerElement: '#healthcare-pin', triggerHook: 'onLeave', duration: $.healthcare.calculatePinDuration })
        .setPin('#healthcare-container .svg-background')
        // .addIndicators({name: 'healthcare pin'})
        .addTo($.controller);

    // zoom

    $.healthcare.zoom = {};

    $.healthcare.tl.zoom = new TimelineMax();

    $.healthcare.tl.zoom.addLabel("start");
    $.healthcare.tl.zoom.addLabel("content", 2);

    if ($.ms || ($.windowWidth > $.breakpoint.e3 && $.safari)) { // zoom

        $.healthcare.tl.zoom.to("#healthcare-svg .svg-text", 2, { y:"-320" }, "start");

    } else {

        $.healthcare.zoom.scale = 10;
        $.healthcare.zoom.offset = $.healthcare.zoom.scale * 100 / 2;
        $.healthcare.zoom.xy = "-"+ $.healthcare.zoom.offset +"%";

        $.healthcare.tl.zoom.to("#healthcare-svg .svg-text", 2, { x:$.healthcare.zoom.xy, y:$.healthcare.zoom.xy, scaleX:$.healthcare.zoom.scale, scaleY:$.healthcare.zoom.scale, force3D:true }, "start");

    }

    $.healthcare.tl.zoom.to("#healthcare-container .svg-img-overlay-mask", 0.5, { opacity:0 }, "start");
    $.healthcare.tl.zoom.to("#healthcare-background", 0.5, { backgroundColor:$.color.black, delay:1 }, "start");
    $.healthcare.tl.zoom.fromTo("#healthcare-svg .svg-img .img-default", 0.5, { opacity:0 }, { opacity:1, delay:1.5 }, "start");
    $.healthcare.tl.zoom.set("#healthcare-svg .svg-bg", { visibility:"hidden", delay:2 }, "start");﻿
    $.healthcare.tl.zoom.set("#healthcare-svg .svg-img-mask", { visibility:"hidden", delay:2 }, "start");﻿

    $.healthcare.tl.zoom.fromTo("#healthcare-container .svg-img-overlay", 0.5, { opacity:0 }, { opacity:1 }, "content");
    $.healthcare.tl.zoom.fromTo("#healthcare-container .svg-content-overlay", 0.5, { opacity:0 }, { opacity:1 }, "content");
    if ($.windowWidth > $.breakpoint.lg) {
        $.healthcare.tl.zoom.fromTo("#healthcare-container .svg-content-overlay", 0.5, { x:"-100%" }, { x:"0%" }, "content");
    }
    $.healthcare.tl.zoom.fromTo("#healthcare-container .content-container", 0.5, { opacity:0 }, { opacity:1, delay:0.5 }, "content");

    new ScrollMagic.Scene({ triggerElement: '#healthcare-zoom', triggerHook: 'onCenter', duration: $.healthcare.zoomDuration })
        .on('start', function () {
            $.healthcare.tl.in.seek($.healthcare.tl.in.duration(), false);
        })
        .setTween($.healthcare.tl.zoom)
        // .addIndicators({name: 'healthcare zoom'})
        .addTo($.controller);

    $.healthcare.tl.out = new TimelineMax();

    $.healthcare.tl.out.addLabel("start");

    $.healthcare.tl.out.to("#healthcare-container .content-container", 1, { opacity:0 }, "start");

    if ($.healthcare.delayFadeOut) {
        $.healthcare.tl.out.to("#healthcare-background", 1, { opacity:0, delay:2 }, "start");
    } else {
        $.healthcare.tl.out.to("#healthcare-background", 1, { opacity:0 }, "start");
    }

    new ScrollMagic.Scene({ triggerElement: '#healthcare-end', triggerHook: 'onCenter', duration: $.healthcare.endDuration })
        .setTween($.healthcare.tl.out)
        // .addIndicators({name: 'healthcare out'})
        .addTo($.controller);

});
